export default {
  acceleration: 0.125 // 30m on 4h
}
